import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_2 = { class: "custom-time-picker-component" }
const _hoisted_3 = { class: "custom-time-picker-hours" }
const _hoisted_4 = ["value", "onChange"]
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "custom-time-picker-minutes" }
const _hoisted_7 = ["value", "onChange"]
const _hoisted_8 = ["value"]

import ValidationErrors from '@/components/Common/ValidationErrors.vue';
import { VueDatePicker } from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import { ja } from 'date-fns/locale'
import { computed } from 'vue';
import i18n from '@/lang/i18n';

const tenMinutesForUnixTime = 10 * 60 * 1000;


export default /*@__PURE__*/_defineComponent({
  __name: 'DatePicker',
  props: {
    label: {},
    required: { type: Boolean, default: false },
    modelValue: {},
    errors: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const floorByTenMinutes = (time: string) => {
  return new Date(time)
};

const datetime = computed({
  get() {
    return floorByTenMinutes(props.modelValue);
  },
  set(value) {
    emit("update:modelValue", value);
  },
})

const hoursArray = computed(() => {
  const arr = [];
  for (let i = 0; i < 24; i++) {
    arr.push({ text: i < 10 ? `0${i}` : i, value: i });
  }
  return arr;
});

const minutesArray = computed(() => {
  const arr = [];
  for (let i = 0; i < 60; i++) {
    arr.push({ text: i < 10 ? `0${i}` : i, value: i });
  }
  return arr;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ValidationErrors, { messages: __props.errors }, {
    default: _withCtx(() => [
      _createElementVNode("label", null, [
        _createTextVNode(_toDisplayString(props.label) + " ", 1),
        (props.required)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, "✴︎"))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_unref(VueDatePicker), {
        locale: _unref(ja),
        "cancel-text": _unref(i18n).global.t('pages.common.datePicker.select'),
        "select-text": _unref(i18n).global.t('pages.common.datePicker.cancel'),
        modelValue: datetime.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((datetime).value = $event)),
        formats: { input: 'yyyy-MM-dd HH:mm' },
        flow: ['calendar'],
        "text-input": false,
        clearable: false,
        autoApply: "",
        closeOnAutoApply: false,
        class: "mt-2",
        error: __props.errors?.length ?? 0 > 0
      }, {
        "time-picker": _withCtx(({ time, updateTime }) => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("select", {
                class: "select-input",
                value: time.hours,
                onChange: ($event: any) => (updateTime({ ...time, hours: +$event.target.value }))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hoursArray.value, (h) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: h.value,
                    value: h.value
                  }, _toDisplayString(h.text), 9, _hoisted_5))
                }), 128))
              ], 40, _hoisted_4),
              _createElementVNode("span", null, _toDisplayString(_unref(i18n).global.t('pages.common.datePicker.time')), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("select", {
                class: "select-input",
                value: time.minutes,
                onChange: ($event: any) => (updateTime({ ...time, minutes: +$event.target.value }))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(minutesArray.value, (m) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: m.value,
                    value: m.value
                  }, _toDisplayString(m.text), 9, _hoisted_8))
                }), 128))
              ], 40, _hoisted_7),
              _createElementVNode("span", null, _toDisplayString(_unref(i18n).global.t('pages.common.datePicker.minute')), 1)
            ])
          ])
        ]),
        _: 1
      }, 8, ["locale", "cancel-text", "select-text", "modelValue", "error"])
    ]),
    _: 1
  }, 8, ["messages"]))
}
}

})